export default __webpack_public_path__ + "static/media/mobile-repair.16cb3bd3.jpg";